var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.5 6H7a.5.5 0 1 1 0-1h1.5c1.103 0 2-.897 2-2s-.897-2-2-2H3c-1.103 0-2 .897-2 2s.897 2 2 2a.5.5 0 1 1 0 1C1.345 6 0 4.654 0 3c0-1.655 1.345-3 3-3h5.5c1.655 0 3 1.345 3 3 0 1.654-1.345 3-3 3zM13 8.5H7.5c-1.654 0-3-1.346-3-3 0-1.655 1.346-3 3-3H9a.5.5 0 1 1 0 1H7.5c-1.103 0-2 .897-2 2s.897 2 2 2H13c1.103 0 2-.897 2-2s-.897-2-2-2a.5.5 0 1 1 0-1c1.655 0 3 1.345 3 3 0 1.654-1.345 3-3 3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-4h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a7ffe82a9a140048df4822ab1da0fc38.svg";
export { ForwardRef as ReactComponent };